var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 31.5,
    width: 347,
    height: 337,
    style: {
      fill: "rgba(255, 255, 255, 1.000000)",
      strokeWidth: "11.000000px",
      stroke: "rgba(0, 0, 0, 1.000000)"
    },
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.000000,58.000000 L430.000000,58.000000 ",
    style: {
      fill: "rgba(255, 255, 255, 1.000000)",
      strokeWidth: "11.000000px",
      stroke: "rgba(0, 0, 0, 1.000000)"
    },
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.000000,32.000000 L26.000000,368.000000 ",
    style: {
      fill: "rgba(255, 255, 255, 1.000000)",
      strokeWidth: "11.000000px",
      stroke: "rgba(0, 0, 0, 1.000000)"
    },
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.000000,368.000000 L30.000000,28.000000 ",
    style: {
      fill: "rgba(255, 255, 255, 1.000000)",
      strokeWidth: "11.472393px",
      stroke: "rgba(0, 0, 0, 1.000000)"
    },
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 11.472393
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae5dc0a89b8491f754f332eb1d52345b.svg";
export { ForwardRef as ReactComponent };